<template>
  <div id="_2022_1">
    <div id="The-second-Asian-young-geographers-workshop" class="cos-modal">
      <h3><strong>The Second Asian Young Geographers Workshop Held Online</strong></h3>
      <small class="home-date">December 17–18, 2022<br></small>
      <hr>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The Second Asian Young Geographers Workshop was held online on
        December 17–18, 2022. Initiated by the Young Geographers Working Group of the Asian
        Geographical Association (AGA-YGWG), the workshop was jointly organized with the IGU
        Task Force for Young and Early Career Geographers (IGU-YECG), the Working Committee for
        Young Geographers of the Geographical Society of China (GSC-WCYG), and the Young Scientist
        Innovation Network of the International Society for Digital Earth (ISDE-YSIN). Under the
        theme “Sustainable Development and Challenges Facing Asia,” the workshop invited eight
        experts and scholars to deliver keynote presentations. Discussions were organized around
        13 related topics, and 206 scholars gave oral presentations. More than 400 scholars from
        28 countries and regions around the world participated online.
      </p>

      <div class="pic">
        <img
          src="../../../assets/static/img/Events/2022_1/workshop-overview.png"
          alt="The Second Asian Young Geographers Workshop, December 17–18, 2022"
        >
      </div>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The workshop officially opened at 11:00 a.m. Beijing Time on
        December 17. The opening ceremony was chaired by Prof. Min Chen of Nanjing Normal
        University, Chair of AGA-YGWG. Prof. Yuji Murayama of the University of Tsukuba, Vice
        President of the Asian Geographical Association; Prof. Michael Meadows of the University
        of Cape Town, President of the International Geographical Union; Prof. Erfu Dai of the
        Institute of Geographic Sciences and Natural Resources Research, Chinese Academy of
        Sciences, Chair of GSC-WCYG; and Dr. Zhen Liu of the Secretariat of the International
        Society for Digital Earth attended the ceremony and delivered welcome addresses on behalf
        of their respective organizations.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The first keynote session followed and was chaired by Associate
        Prof. Li He of Xi’an Jiaotong University, Secretary General of AGA-YGWG. The invited
        speakers were Academician Fahu Chen, President of the Geographical Society of China and a
        researcher at the Institute of Tibetan Plateau Research, Chinese Academy of Sciences;
        Prof. Jiang Xu of The Chinese University of Hong Kong; Associate Prof. Kazumasa Hanaoka
        of Ritsumeikan University, Japan; Associate Prof. Martin Stefan Brandt of the University
        of Copenhagen, Denmark; and Dr. Prajal Pradhan of the Potsdam Institute for Climate Impact
        Research, Germany. They delivered keynote presentations entitled “Trans-Eurasian
        Exchanges and Climate Change along the Silk Road,” “‘Asian Geographer’: Join Us in
        Building an International Journal Rooted in Asia,” “Mobile Phone Big Data and the
        COVID-19 Pandemic,” “Continental-Scale Mapping of Vegetation Carbon Stocks,” and
        “Building on the Sustainable Development Goals to Transform toward Long-Term
        Sustainability,” respectively. On the afternoon of December 17, young geographers from
        different countries presented and discussed their research in parallel online sessions.
        Topics included geographic model visualization; climate hazards and their impacts; water
        resources; big-data solutions for disaster prevention, mitigation, and environmental
        governance; spatial technologies for public health and the social sciences; security
        geography; and applications of spatial geography in land management.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The second keynote session was held on the morning of December 18
        and chaired by Associate Prof. Zhuo Wu of Guangzhou University, Deputy Secretary General
        of GSC-WCYG. Associate Research Fellow Jie Huang of the Institute of Geographic Sciences
        and Natural Resources Research, Chinese Academy of Sciences; Researcher Fang Chen of the
        Institute of Remote Sensing and Digital Earth, Chinese Academy of Sciences; and Prof.
        Narendra Raj Khanal of Tribhuvan University, former President of the Nepal Geographical
        Society, delivered presentations entitled “Rethinking Transport Resilience: New Advances
        in Travel Behavior Analysis,” “Digital Technologies for Sustainable Development and
        Disaster Risk Reduction,” and “Advances in Mountain Research in Asia: The Nepal Himalaya
        as a Case Study,” respectively. Later that day, participating young scholars continued
        with parallel presentations and academic discussions on marine sustainability; monitoring
        ecosystem structure and function; developments in tourism geography in Asia; the use of
        remote-sensing data in sustainability analysis; ecosystem conservation on the
        Qinghai–Tibet Plateau; comparative urban geography; sustainable urban landscapes in Asia;
        and frontier research and applications concerning public health and well-being.
      </p>

      <div class="pic">
        <img
          src="../../../assets/static/img/Events/2022_1/workshop-closing.png"
          alt="Participants in the online workshop"
        >
      </div>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;The closing ceremony was held on the afternoon of December 18 and
        chaired by Associate Prof. Li He. Prof. Min Chen delivered the concluding remarks,
        reporting the workshop’s initial outcomes, introducing the organizational structure and
        recent activities of AGA-YGWG, and thanking the other organizing committee members and
        volunteers. Researcher Guoyou Zhang, Vice President and Secretary General of the
        Geographical Society of China, then announced the winners of the Best Paper Awards.
        Following a comprehensive assessment by the workshop’s review committee, ten papers were
        selected. Four award recipients—Zhaoyin Liu of the National University of Singapore,
        Muhammad Zubair of the National University of Sciences and Technology, Pakistan, Sanjit
        Sarkar of the Central University of Karnataka, India, and Lingfeng He of Xi’an Jiaotong
        University—gave acceptance speeches.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Against the backdrop of the continuing pandemic, frequent
        disasters, and compounding ecological and environmental crises in recent years, the
        workshop provided a venue for sharing the latest research by Asian geographers on global
        sustainability challenges, particularly those facing Asia. It also promoted exchange and
        collaboration among young geographers across Asian countries. The Asian Young
        Geographers Workshop pioneered a new forum for exchange among young geographers in Asia.
        Its inaugural meeting in December 2021 created a new platform for communication and
        advanced both geographical exchange in Asia and the development of the Asian Geographical
        Association. The successful second workshop expanded the platform’s influence and further
        strengthened its identity and continuity. According to the organizers, as the global
        pandemic gradually subsides, the next workshop is expected to be held in person.
      </p>

      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;Established in 2020, the Young Geographers Working Group of the
        Asian Geographical Association (AGA-YGWG) aims to provide young geographers with a
        platform for collaboration and academic exchange. Focusing on major issues such as the
        environment, health, and sustainable development, it brings together young geographers
        from physical geography, human geography, geographic information science, and related
        fields to build a closely connected Asian academic community.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: '_2022_1'
}
</script>

<style lang="less" scoped>
#_2022_1 {
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 2.2rem auto 0;
  position: relative;
  word-spacing: 0.3rem;
  min-height: 2500px;
  text-align: justify;
}

h3 {
  color: #117450;
  font-size: 1.3rem;
  font-weight: 1000;
}

.home-date {
  font-weight: bold;
  color: grey;
}

.pic {
  width: 100%;
  margin: 2% 0;
  text-align: center;
}

.pic img {
  display: inline-block;
  max-width: 80%;
  height: auto;
}

@media (max-width: 768px) {
  #_2022_1 {
    width: 88%;
    min-height: 0;
  }

  .pic img {
    max-width: 100%;
  }
}
</style>
